export function createPerformanceLogger(name: string) {
  const start = performance.now();
  console.log(`${name} started`);
  return (keys: string | string[] = '') => {
    if (Array.isArray(keys)) {
      keys = keys.join(' ');
    }
    const end = performance.now();
    console.log(name, keys, Math.round(end - start));
  };
}
